<template>
  <div class="grid --align-top">
    <form
      :action="action"
      method="post"
      @submit.prevent="formSubmit"
      class="form-container +mg-bottom-xs"
    >
      <div class="grid --align-top">
        <div class="grid-cell size-fill--sm +mg-bottom +mg-right-xs">
          <div class="form-control" :class="{ '--is-successful': showSuccess }">
            <label
              class="form-label --floated --right-addon --inverted"
              for="textInput"
            >
              Email
            </label>
            <input
              class="form-input --inverted"
              type="email"
              name="email"
              id="email"
              required
              v-model="email"
              :disabled="showSuccess ? true : false"
            />
          </div>
        </div>
        <div class="grid-cell size-fit--sm +mg-right-xs">
          <button class="button --primary" type="submit">
            {{ buttonText }}
          </button>
        </div>
      </div>
      <span class="form-element-help --is-successful" v-if="showSuccess">
        SUCCESS! {{ formattedEmail }} has been subscribed!
      </span>
      <span class="form-element-help --has-error" v-if="showError">
        Subscription failed! Our team has been notified. Please try again later.
      </span>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import tagularModule from 'js/store/helpers/tagular'
import tagularAuthenticatedModule from 'js/store/helpers/tagular-authenticated'

export default {
  props: {
    action: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: false,
      default: 'Sign Up Today'
    },
    event: {
      type: String,
      required: false,
      default: ''
    },
    name: {
      type: String,
      required: false,
      default: ''
    }
  },
  mounted() {
    this.trackViewed()
    window.addEventListener('scroll', () => this.trackViewed())
  },
  data() {
    return {
      email: '',
      source: 'br3',
      showError: false,
      showSuccess: false,
      formType: 'AUTHENTICATION',
      formName: this.name,
      formId: tagularModule.generateUniqueId(),
      stepName: 'Verify_Identity_Emailonly',
      stepType: 'CONFIRMATION',
      stepId: tagularModule.generateUniqueId(),
      viewed: false
    }
  },
  computed: {
    formattedEmail() {
      if (this.email.length === 0) {
        return this.email
      }

      return this.email.substring(0, 1).toUpperCase() + this.email.substring(1)
    }
  },
  methods: {
    formSubmit() {
      let payload = {
        email: this.email,
        source: this.source
      }
      this.showError = false
      this.showSuccess = false
      if (this.event) {
        payload['event'] = this.event
      }
      this.trackFormSubmitted()
      return axios
        .post(this.action, payload, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-Form-Name': `${this.formName}`,
            'X-Form-Id': `${this.formId}`,
            'X-Form-Type': `${this.formType}`
          },
          responseType: 'json'
        })
        .then(() => {
          this.showSuccess = true
          this.trackFormOutcomeReceived()
          dataLayer = window.dataLayer || []
          dataLayer.push({
            event: 'e_navEmail'
          })
        })
        .catch(error => {
          this.showError = true
          console.error('Email subscription form submission failed', error) // eslint-disable-line no-console
        })
    },
    elementViewed() {
      let dimensions = this.$el.getBoundingClientRect()
      let distanceFromTopOfScreen = dimensions.y
      let screenHeight = window.innerHeight

      if (dimensions.height === 0 || dimensions.width === 0) {
        return false
      }

      if (
        distanceFromTopOfScreen < screenHeight &&
        distanceFromTopOfScreen >= 0
      ) {
        return true
      }

      return false
    },
    trackViewed() {
      const webElement = {
        location: 'Homebuying Page',
        position: 'bottom of homebuying page',
        elementType: 'email capture form',
        text: 'Homebuying Page',
        htmlId: 'home-buying-guide'
      }
      if (this.elementViewed() && !this.viewed) {
        this.viewed = true
        tagularModule.elementViewed(webElement)
        this.trackFormStarted()
      }
    },
    trackFormStarted() {
      tagularAuthenticatedModule.formAuthenticatedStarted(
        this.formType,
        this.formName,
        this.formId,
        this.stepName,
        this.stepType,
        this.stepId
      )
    },
    trackFormSubmitted() {
      tagularAuthenticatedModule.formAuthenticatedSubmitted(
        this.formType,
        this.formName,
        this.formId,
        this.stepName,
        this.stepType,
        this.stepId
      )
    },
    trackFormOutcomeReceived() {
      tagularAuthenticatedModule.formOutcomeReceived(
        this.formType,
        this.formName,
        this.formId,
        this.stepName,
        this.stepType,
        this.stepId
      )
    }
  }
}
</script>
